import {CONFIG, MODEL_IDS, ModelId} from './config';

interface ModelRouteLocation {
  pathname: string;
  search: string;
}

const MODEL_SLUGS: Record<string, ModelId> = {
  mamay: MODEL_IDS.mamay,
  mamaylm: MODEL_IDS.mamay,
  lapa: MODEL_IDS.lapa,
  lapallm: MODEL_IDS.lapa,
  rada: MODEL_IDS.rada,
  rukopys: MODEL_IDS.rukopys,
  ocr: MODEL_IDS.rukopys,
  'rukopys-ocr': MODEL_IDS.rukopys,
};

const CANONICAL_SLUGS: Record<ModelId, string> = {
  [MODEL_IDS.mamay]: 'mamay',
  [MODEL_IDS.lapa]: 'lapa',
  [MODEL_IDS.rada]: 'rada',
  [MODEL_IDS.rukopys]: 'rukopys',
};

function resolveModel(value: string | null): ModelId | null {
  if (!value) return null;
  let normalized: string;
  try {
    normalized = decodeURIComponent(value).trim().toLowerCase();
  } catch {
    return null;
  }
  const exact = CONFIG.models.find(model => model.id.toLowerCase() === normalized);
  return exact?.id || MODEL_SLUGS[normalized] || null;
}

export function modelIdFromUrl(location: ModelRouteLocation): ModelId | null {
  const route = /^\/(?:chat\/)?([^/]+)\/?$/.exec(location.pathname);
  const routeModel = resolveModel(route?.[1] || null);
  if (routeModel) return routeModel;
  return resolveModel(new URLSearchParams(location.search).get('model'));
}

export function modelChatPath(modelId: ModelId): string {
  return `/${CANONICAL_SLUGS[modelId]}`;
}
